/**
 * Determines whether or not an object is a function.
 * @public
 */
export const isFunction = (object) => typeof object === "function";
